import React, { useEffect } from "react";
import { Typography, Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSelector } from "react-redux";
import { getProfileInfo, getTooltipMsgs } from "selectors/energyAssistance.selectors";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { initialState } from "container/energyAssistance/store/initialState";
import { API_LOAD_STATUS } from "constants/labels";
import { InfoTooltip } from "_components";

const Profileinformation = () => {
  const profileInfo = useSelector(getProfileInfo);
  const tooltipMsgs = useSelector(getTooltipMsgs);
  const getTooltip = (title) =>
    tooltipMsgs?.Data?.find((t) => t.TooltipTitle === title)?.TooltipMsg;
  const { Data, Load, Succeeded } = profileInfo || initialState.profileInfo;
  const {
    AccountNumber,
    CustomerName,
    SecondaryName,
    ServiceAddress,
    HomePhone,
    MobileNumber,
    WorkPhone,
    ServiceOn,
    HeatingAccount,
  } = Data || initialState.profileInfo.Data;

  return (
    <Box
      className="userInformationcontainer"
      sx={{ height: "100% !important" }}
    >
      <Accordion component="div" defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          component="div"
        >
          <Typography component="h2" className="userInformation">
            Profile Information
            <InfoTooltip
              title="Profile Information"
              message={getTooltip("Profile Information")}
            />
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {Load.status === API_LOAD_STATUS.FULFILLED && Succeeded && (
            <Grid container spacing={3}>
              <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                <Typography component="div" className="UserName">
                  <Grid container spacing={3}>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                      <Typography component="span" className="textleft">
                        Customer Name
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                      <Typography component="span" className="textright">
                        {CustomerName || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Typography>

                <Typography component="div" className="UserName">
                  <Grid container spacing={3}>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                      <Typography component="span" className="textleft">
                        Secondary Name
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                      <Typography component="span" className="textright">
                        {SecondaryName || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Typography>

                <Typography component="div" className="UserName">
                  <Grid container spacing={3}>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                      <Typography component="span" className="textleft">
                        Account Number
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                      <Typography component="span" className="textright">
                        {AccountNumber || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Typography>

                <Typography component="div" className="UserName">
                  <Grid container spacing={3}>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                      <Typography component="span" className="textleft">
                        Service Address
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                      <Typography component="span" className="textright">
                        {ServiceAddress || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Typography>

                <Typography component="div" className="UserName">
                  <Grid container spacing={3}>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                      <Typography component="span" className="textleft">
                        Phone Number
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                      <Typography component="span" className="textright">
                        {HomePhone || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Typography>

                <Typography component="div" className="UserName">
                  <Grid container spacing={3}>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                      <Typography component="span" className="textleft">
                        Mobile Number
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                      <Typography component="span" className="textright">
                        {WorkPhone || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Typography>

                <Typography component="div" className="UserName">
                  <Grid container spacing={3}>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                      <Typography component="span" className="textleft">
                        Service Status
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                      <Typography component="span" className="textright">
                        {ServiceOn ? (
                          <CheckCircleOutlineIcon
                            className="greenCheckIcon"
                            sx={{
                              fontSize: 16,
                            }}
                          />
                        ) : (
                          <CancelOutlinedIcon
                            className="redCancelIcon"
                            sx={{
                              fontSize: 16,
                            }}
                          />
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                </Typography>

                <Typography component="div" className="UserName">
                  <Grid container spacing={3}>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                      <Typography component="span" className="textleft">
                        Heating Account
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                      <Typography component="span" className="textright">
                        {HeatingAccount ? (
                          <CheckCircleOutlineIcon
                            className="greenCheckIcon"
                            sx={{
                              fontSize: 16,
                            }}
                          />
                        ) : (
                          <CancelOutlinedIcon
                            className="redCancelIcon"
                            sx={{
                              fontSize: 16,
                            }}
                          />
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                </Typography>
              </Grid>
            </Grid>
          )}
          {Load.status === API_LOAD_STATUS.PENDING && (
            <Typography component="p" sx={{ textAlign: "center" }}>
              Loading Personal Information...
            </Typography>
          )}
          {(Load.status === API_LOAD_STATUS.REJECTED ||
            Load.status === API_LOAD_STATUS.FULFILLED) &&
            !Succeeded && (
              <Typography component="p" sx={{ textAlign: "center" }}>
                {Load.message || "No records to display."}
              </Typography>
            )}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default Profileinformation;
